import React, { Component } from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';
import queryString from 'query-string';
import DashboardSummary from '../../../../CommonComponents/AccountInformation/Grants/DashboardSummary/DashboardSummary';
import CarouselComponent from '../../../../CommonComponents/Carousel/CarouselComponent';
import TabsComponent from './components/TabsComponent/TabsComponent';
import BalanceCards from '../../../../CommonComponents/BalanceCards/BalanceCards';
import IssuedGrants from './components/IssuedGrants/IssuedGrants';
import {
  fetchGrantsDashboardData,
  fetchLazyLoadData,
  restoreData,
} from './actions';
import {
  CommonCard,
  FixedWidth,
  SemiDarkerDivider,
  TabFooter,
  NotifyText,
} from '../../../../CommonComponents/commonStyles';
import {
  grantsOverviewStates
} from './selectors';
import {
  renderDashboardFixGrid,
  renderGrantAmountGrid1,
  renderContributionsDateGrid,
  renderDescriptionGrid,
} from '../../../../utils/cardGrid';
import {
  renderGrantsFixGrid,
  renderPurposeFixGrid,
  renderUserNameFixGrid,
  renderGrantTitleGrid,
  renderPurposesFixGrid,
  renderGrantAmountGrid,
  renderDescriptionsGrid,
  renderGrantsIssuedDateGrid,
  renderUserFixGrid,
  renderGrantsCheckGrid,
} from './utils';
import { disabledValidator, disabledText } from './utils';
import { connect } from 'react-redux';
import {
  GrantsDashboardBody,
  MarginWrapper,
  GrantsMargin,
  GrantsHead,
  DateNow,
  GrantGreyBackgroundSection,
  ActivityHead,
  ChartData,
} from './styles';
import BreadcrumbComponent from '../../../../CommonComponents/Breadcrumb/Breadcrumb';
import { getPrimaryAccount } from '../../../../utils/sessionUtil';
import BOTChart from './components/GrantsChart/GrantChart';
import { getGrantsApi } from './config';
import ToJS from './components/HOC/toJS';
import Preloader from '../../../../CommonComponents/Preloader/Preloader';
import {
  startDate,
  todayDate,
  initiateTracking,
} from '../../../../utils/commonUtil';
import CharitySelect from './components/CharitySelect/CharitySelect';
import { ActivityText } from '../../../Contributions/Pages/ContributionsDashboard/styles';
import { selectHeader } from '../../../../actions/globalActions';
import {
  Types,
  ContentProvider,
} from '../../../../CommonComponents/ContentMessages';
import PropTypes from 'prop-types';
import {
  TooltipWrapper,
  GeneralButton,
} from '../../../../CommonComponents/Commons/commonComponents';

export class GrantsDashboard extends Component {
  state = {
    grantsData: [],
    grantsDataAll: [],
  };

  completedContribRef = React.createRef();
  title = 'Grants Overview';
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.requestData(getGrantsApi());
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.accountID != nextProps.accountID) {
      this.props.restoreDefaults();
      this.props.requestData(getGrantsApi());
    }

    if (!nextProps.isGrantsLoading) {
      this.setGrantsData(nextProps);
    }

    if (!nextProps.isAllGrantsLoading) {
      this.setGrantsAllData(nextProps);
    }
  }

  setGrantsData(data) {
    var oneYearData = data.grantsData;
    this.setState({
      grantsData: oneYearData,
    });
  }

  setGrantsAllData(data) {
    var fiveYearData = data.allGrantsData;
    this.setState({
      grantsDataAll: fiveYearData,
    });
  }

  scrollEventHandler = (e, type) => {
    var elem = e.target;
    var setScroll = 0;
    if (
      Math.ceil(elem.scrollHeight) - Math.ceil(elem.scrollTop) <=
      elem.clientHeight
    ) {
      if (type === 'Pending Grants' && this.props.pendingDataAvailable) {
        setScroll = elem.scrollTop;
        this.props.getLazyData({
          metaData: [
            {
              method: 'GET',
              url: `/donor-portal/api/grant/${
                getPrimaryAccount().userId
              }/getGrantsByAccountIdAndPartyIdAndTypeAndPagination?startDateStr=${startDate(
                90
              )}&endDateStr=${todayDate()}&type=PENDING&page=${
                this.props.currentPending
              }`,
              page: 'grantsDashboard',
              type: 'PENDING',
              elem: elem,
              setScroll: setScroll,
            },
          ],
        });
        elem.scrollTop = setScroll;
      } else if (
        type === 'Issued Grants' &&
        this.props.completedDataAvailable
      ) {
        setScroll = elem.scrollTop;
        this.props.getLazyData({
          metaData: [
            {
              method: 'GET',
              url: `/donor-portal/api/grant/${
                getPrimaryAccount().userId
              }/getGrantsByAccountIdAndPartyIdAndTypeAndPagination?startDateStr=${startDate(
                90
              )}&endDateStr=${todayDate()}&type=ISSUED&page=${
                this.props.issuedPagination
              }`,
              page: 'grantsDashboard',
              type: 'COMPLETED',
            },
          ],
        });
        elem.scrollTop = setScroll;
      }
    }
  };

  goToPage = (pathName, query, selectedHeader, data) => {
    selectedHeader && this.props.selectHeader(selectedHeader);
    if (pathName === '/grants/activity/view') {
      let checkClearedDate = data.checkClearedDate;
      this.props.history.push({
        pathname: pathName,
        search: queryString.stringify({ grantId: data.txnId }),
        state: { checkClearedDate },
      });
    } else if (query) {
      this.props.history.push(pathName + query);
    } else {
      this.props.history.push(pathName);
    }
  };

  goToGrants = (data) => {
    let query = `?grantId=`;
    let url = '/grants/activity/view';
    if (data.grantAgreement) {
      url = '/grants/grant-agreement/view';
    }
    this.goToPage(url, query + data.txnId, '', data);
  };

  analyticsHandler = (eventType, action, name) => {
    initiateTracking(
      eventType,
      this.title,
      action ? action : '',
      name ? name : ''
    );
  };

  goFromCardsToPage = (e, pathName, query, selectedHeader) => {
    e.preventDefault();
    selectedHeader && this.props.selectHeader(selectedHeader);
    if (query) {
      this.props.history.push(pathName + query);
    } else {
      this.props.history.push(pathName);
    }
  };

  render() {
    const {
      accData,
      accIsLoading,
      isLazyLoading,
      currentPendingGrants,
      isLoadingCurrentPendingGrants,
      issuedGrants,
      isLoadingIssuedGrants,
      grantsCount,
    } = this.props;

    let primaryAccount = getPrimaryAccount();
    if (
      typeof accData != 'null' &&
      typeof accData == 'object' &&
      primaryAccount
    )
      accData.roleAccess = primaryAccount.role.access;
    if (accIsLoading) return <Preloader />;

    const BalanceCardsConfiguration = [
      {
        heading: 'Current Balance',
        balance: accData && accData.currentBalance,
        text:
          'Balance in your donor-advised fund after the previous day’s trading cycle is complete',
        url: '/',
        buttonName: 'View Account summary',
        pageName: 'ACCOUNT SUMMARY',
        id: 'anrViewAccountSummary',
      },
      {
        heading: 'Available Balance',
        balance: accData && accData.availableBalance,
        text:
          'Your current balance, minus any pending grants, pending exchanges, or assets invested in TIFF',
        url: '/my-account/transaction-summary',
        buttonName: 'View Transaction Summary',
        pageName: 'Transaction Summary',
        id: 'anrViewTransactionSummary',
      },
      {
        heading: 'Grants Issued YTD',
        balance: grantsCount && grantsCount.grantIssuedYTD,
        text: 'Total dollar amount for all issued grants for this year. ',
        url: '/grants/activity',
        buttonName: 'View Grant Activity',
        comingSoon: false,
        pageName: 'Grant Activity',
        id: 'anrViewGrantActivity',
      },
    ];

    // removing cancelled grants
    let updatedIssuedGrants = issuedGrants.filter((grant) => {
      if (grant.status !== 'Cancelled') {
        return true;
      }
    });

    const tabConfig = function destObj(data, index, clicked, item) {
      return [
        {
          config: [
            {
              name: 'txnId',
              type: 'TitleGrid',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderGrantTitleGrid({
                data,
                each: 'txnId',
                label: 'Transaction Id',
                index: index,
                comingSoon: false,
                handleTitleClick: () => clicked(data, item),
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'grantName',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderDescriptionGrid({
                data,
                each: 'charityName',
                label: 'Grant Name',
                index: index,
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'requestedDeliveryDate',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderContributionsDateGrid({
                data,
                each: 'dateRequested',
                label: 'Requested Delivery Date',
              }),
              ptop: false,
              pbottom: true,
              noBorderBottom: true,
            },
            {
              name: 'amount',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderGrantAmountGrid1({
                data,
                each: 'amount',
                label: 'Amount',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'purpose',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderPurposeFixGrid({
                data,
                each: 'purpose',
                label: 'Purpose',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'status',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderDashboardFixGrid({
                data,
                each: 'status',
                label: 'Status',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'userName',
              type: 'Data',
              gridWidth: '30',
              mobileGridWidth: '100',
              render: renderUserNameFixGrid({
                data,
                each: 'userName',
                label: 'Entered By',
                index: index,
              }),
              ptop: false,
              pbottom: false,
            },
          ],
        },
        {
          config: [
            {
              name: 'txnId',
              type: 'TitleGrid',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderGrantTitleGrid({
                data,
                each: 'txnId',
                label: 'Transaction Id',
                index: index,
                comingSoon: false,
                handleTitleClick: () => clicked(data, item),
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'grantName',
              gridWidth: '100',
              mobileGridWidth: '100',
              render: renderDescriptionGrid({
                data,
                each: 'charityName',
                label: 'Grant Name',
                index: index,
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'issueDate',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderContributionsDateGrid({
                data,
                each: 'issuedate',
                label: 'Issue Date',
              }),
              ptop: false,
              pbottom: true,
              noBorderBottom: true,
            },
            {
              name: 'amount',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderGrantAmountGrid1({
                data,
                each: 'amount',
                label: 'Amount',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'purpose',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderPurposeFixGrid({
                data,
                each: 'purpose',
                label: 'Purpose',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'status',
              gridWidth: '30',
              mobileGridWidth: '50',
              render: renderDashboardFixGrid({
                data,
                each: 'status',
                label: 'Status',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'userName',
              type: 'Data',
              gridWidth: '30',
              mobileGridWidth: '100',
              render: renderUserNameFixGrid({
                data,
                each: 'userName',
                label: 'Entered By',
                index: index,
              }),
              ptop: false,
              pbottom: false,
            },
          ],
        },
      ];
    };

    const issuedGrantsConfig = function destObj(data, index, clicked, item) {
      return [
        {
          config: [
            {
              name: 'txnId',
              type: 'Data',
              gridWidth: '50',
              render: renderGrantTitleGrid({
                data,
                each: 'txnId',
                label: 'Transaction Id',
                index: index,
                handleTitleClick: () => clicked(data, item),
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'Charity Name',
              type: 'TitleGrid',
              gridWidth: '100',
              render: renderDescriptionsGrid({
                data,
                each: 'charityName',
                label: '',
                index: index,
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false,
            },
            {
              name: 'originalIssueDate',
              gridWidth: '50',
              render: renderGrantsIssuedDateGrid({
                data,
                each: 'issuedate',
                label: 'Original issue date',
                altLabel: 'Re-issued date',
                altEach: 'stopAndReissueChkDate',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'Check',
              gridWidth: '50',
              render: renderGrantsCheckGrid({
                data,
                each: 'checkNumber',
                label: 'Check #',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'amount',
              gridWidth: '50',
              render: renderGrantAmountGrid({
                data,
                each: 'amount',
                label: 'Amount',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'purpose',
              gridWidth: '50',
              render: renderPurposesFixGrid({
                data,
                each: 'purpose',
                label: 'Purpose',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'status',
              gridWidth: '50',
              render: renderGrantsFixGrid({
                data,
                each: 'status',
                label: 'Status',
              }),
              ptop: false,
              pbottom: true,
            },
            {
              name: 'Entered By',
              gridWidth: '50',
              render: renderUserFixGrid({
                data,
                each: 'status',
                label: 'Entered By',
              }),
              ptop: false,
              pbottom: true,
            },
          ],
        },
      ];
    };

    const tabPanes = [
      {
        title: 'Pending Grants',
        key: 1,
        destComponent: 'card',
        mobComponent: 'card',
        data: currentPendingGrants,
        isLoading: isLoadingCurrentPendingGrants,
        text: 'No pending grants have been made in the last 90 days.',
      },
      {
        title: 'Issued Grants',
        key: 2,
        destComponent: 'card',
        mobComponent: 'card',
        data: updatedIssuedGrants,
        isLoading: isLoadingIssuedGrants,
        text: 'No issued grants have been made in the last 90 days.',
      },
    ];

    this.breadcrumbRoutes = () => {
      return [
        {
          routeName: 'Home',
          path: '/',
        },
        {
          routeName: 'Grants Overview',
          path: '',
        },
      ];
    };
    return (
      <ContentProvider
        types={[Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_ALERTS]}
        pages={['Grants Overview']}
      >
        <GrantsDashboardBody className='Analytics_grantingDashboard'>
          <FixedWidth>
            <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          </FixedWidth>
          <DashboardSummary
            accData={accData}
            handleLinkAnalytics={(eventType, action, name) =>
              this.analyticsHandler(eventType, action, name)
            }
          />
          <GrantGreyBackgroundSection>
            <FixedWidth>
              <Row>
                <Col md={{ span: '8' }}>
                  <BalanceCards
                    clicked={(e, pathName, query, selectedHeader) =>
                      this.goFromCardsToPage(e, pathName, query, selectedHeader)
                    }
                    grantsDashboard={true}
                    config={BalanceCardsConfiguration}
                  />
                  <TooltipWrapper
                    text={disabledText(accData)}
                    placement={
                      window.screen.availWidth >= 320 &&
                      425 >= window.screen.availWidth
                        ? 'top'
                        : 'right'
                    }
                    element={
                      <div className='expanded-width'>
                        <GeneralButton
                          data-test='grantsDashboardGrantClick'
                          text='RECOMMEND A GRANT'
                          type='primary'
                          id='btnRecommendagrant'
                          disabled={disabledValidator(accData)}
                          linkPathname='/grants/recommend'
                          width='100%'
                          mobWidth='100%'
                          onClick={() =>
                            this.goToPage(
                              '/grants/recommend',
                              '',
                              'Recommend a grant'
                            )
                          }
                        />
                      </div>
                    }
                  />
                </Col>
                <Col md={{ span: '16' }} className='mt-xs-20'>
                  <GrantsMargin>
                    <CommonCard>
                      <TabsComponent
                        handleTabAnalytics={(eventType, action, tabName) =>
                          this.analyticsHandler(eventType, action, tabName)
                        }
                        dashboard={true}
                        tabPanes={tabPanes}
                        tabConfig={tabConfig}
                        containerHeight={
                          this.props.carouselData.length !== 0
                            ? '264px'
                            : 998 <= window.screen.availWidth &&
                              window.screen.availWidth <= 1024
                            ? '533px'
                            : 768 <= window.screen.availWidth &&
                              window.screen.availWidth <= 997
                            ? '520px'
                            : '524px'
                        }
                        contributionDashboard={true}
                        isLazyLoading={isLazyLoading}
                        scrolled={(event, type) =>
                          this.scrollEventHandler(event, type)
                        }
                        xscrollC={false}
                        transactionClicked={(item) => this.goToGrants(item)}
                      />
                      <SemiDarkerDivider className='my0' />
                      <TabFooter>
                        <GeneralButton
                          type='tertiary'
                          text='View Grant Activity'
                          data-test='data-btnLinkViewGrantActivity'
                          tabNavigation={true}
                          styling='ml3 mt1 mb1'
                          id='btnLinkViewGrantActivity'
                          onClick={() => this.goToPage('/grants/activity')}
                        />
                        <NotifyText>
                          Transactions displayed above are from last 90 days
                        </NotifyText>
                      </TabFooter>
                    </CommonCard>
                  </GrantsMargin>
                  <CarouselComponent isFull />
                </Col>
              </Row>
            </FixedWidth>
          </GrantGreyBackgroundSection>
          <FixedWidth>
            <MarginWrapper>
              <DateNow>Timeline</DateNow>
              <ActivityHead>Grant Activity</ActivityHead>
              <ActivityText>
                This page allows you to review all of your current and past
                grant activity. You can search your grant history by date or
                filter to see fewer grants.{' '}
              </ActivityText>
              <Row>
                {this.props.isGrantsLoading === true ||
                (this.state.grantsData.length === 0 &&
                  this.props.isAllGrantsLoading === true) ? (
                  <div>
                    <div className='noDataPlacement chart-no-data'>
                      <div className='loader-position'>
                        <div>
                          <img
                            src={require('../../../../assets/icons/loader.gif')}
                            className='mr-icon'
                            alt='loader'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : this.props.isGrantsLoading === false &&
                  this.props.isAllGrantsLoading === false ? (
                  this.state.grantsData.length === 0 &&
                  this.state.grantsDataAll.length === 0 ? (
                    <div>
                      <div className='grants-dashboard noDataPlacement chart-no-data'>
                        <ChartData>
                          You currently have no grant activity
                        </ChartData>
                      </div>
                    </div>
                  ) : (
                    <BOTChart
                      handleFilterAnalytics={(eventType, action, tabName) =>
                        this.analyticsHandler(eventType, action, tabName)
                      }
                      isAllGrantsLoading={this.props.isAllGrantsLoading}
                      data_y5={this.props.data_y5}
                      data_all_y5={this.props.data_all_y5}
                      data={this.state.grantsData}
                      dataAll={this.state.grantsDataAll}
                      botStatusText={this.props.botStatusText}
                      additionalDetails={this.props.establishedDate}
                    />
                  )
                ) : (
                  <BOTChart
                    handleFilterAnalytics={(eventType, action, tabName) =>
                      this.analyticsHandler(eventType, action, tabName)
                    }
                    isAllGrantsLoading={this.props.isAllGrantsLoading}
                    data_y5={this.props.data_y5}
                    data_all_y5={this.props.data_all_y5}
                    data={this.state.grantsData}
                    dataAll={this.state.grantsDataAll}
                    botStatusText={this.props.botStatusText}
                    additionalDetails={this.props.establishedDate}
                  />
                )}
              </Row>
            </MarginWrapper>
          </FixedWidth>
          <FixedWidth>
            <div>
              {this.props.selectedIsssuedGrantsError ? (
                <p>Cannot Fetch Grants</p>
              ) : this.props.isLoadingGrants ? (
                <div className='noDataPlacement chart-no-data'>
                  <div className='loader-position'>
                    <div>
                      <img
                        src={require('../../../../assets/icons/loader.gif')}
                        className='mr-icon'
                        alt='loader'
                      />
                    </div>
                  </div>
                </div>
              ) : this.props.selectedIssuedGrants &&
                this.props.isLoadingGrants === false &&
                this.props.showData ? (
                <>
                  <DateNow className='mt-50'>
                    {moment(
                      this.props.selectedIssuedGrants[0].issuedate
                    ).format('LL')}
                  </DateNow>
                  <GrantsHead>Grants Issued</GrantsHead>
                  <div ref={this.completedContribRef} />
                  <IssuedGrants
                    completedContribRef={this.completedContribRef}
                    issuedGrants={this.props.selectedIssuedGrants}
                    config={issuedGrantsConfig}
                    error={this.props.selectedIsssuedGrantsError}
                    transactionClicked={(item) => this.goToGrants(item)}
                  />
                </>
              ) : null}
            </div>
          </FixedWidth>
          <CharitySelect
            comingSoon={false}
            fromPage='GD'
            isFull
            activityBlocked={disabledText(accData)}
          />
        </GrantsDashboardBody>
      </ContentProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  ...grantsOverviewStates(state.toJS())
});

export const mapDispatchToProps = (dispatch) => ({
  requestData: (data) => dispatch(fetchGrantsDashboardData(data)),
  getLazyData: (data) => dispatch(fetchLazyLoadData(data)),
  restoreDefaults: () => dispatch(restoreData()),
  selectHeader: (data) => dispatch(selectHeader(data)),
});

export default ToJS(
  connect(mapStateToProps, mapDispatchToProps)(GrantsDashboard)
);

GrantsDashboard.propTypes = {
  isAllGrantsLoading: PropTypes.bool,
  isGrantsLoading: PropTypes.bool,
  isLazyLoading: PropTypes.bool,
  isLoadingCurrentPendingGrants: PropTypes.bool,
  isLoadingGrants: PropTypes.bool,
  isLoadingIssuedGrants: PropTypes.bool,
  data_all_y3: PropTypes.bool,
  data_all_y5: PropTypes.bool,
  data_y3: PropTypes.bool,
  data_y5: PropTypes.bool,
  pendingDataAvailable: PropTypes.bool,
  requestData: PropTypes.func,
  restoreDefaults: PropTypes.func,
  selectHeader: PropTypes.func,
  getLazyData: PropTypes.func,
  accIsLoading: PropTypes.bool,
  allGrantsData: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      availableBalance: PropTypes.number,
      charityName: PropTypes.string,
      checkClearedDate: PropTypes.number,
      checkNumber: PropTypes.number,
      csrDPFlow: PropTypes.bool,
      csrFlow: PropTypes.bool,
      currentBalance: PropTypes.number,
      dateRequested: PropTypes.number,
      dpUser: PropTypes.string,
      dpUserFirstName: PropTypes.string,
      dpUserLastName: PropTypes.string,
      dpUserMiddleName: PropTypes.string,
      dpUserPrefix: PropTypes.string,
      dpUserSuffix: PropTypes.string,
      enteredDate: PropTypes.number,
      grantAgreement: PropTypes.bool,
      isRecurring: PropTypes.string,
      issuedate: PropTypes.number,
      purpose: PropTypes.object,
      status: PropTypes.string,
      stopAndReissueChkDate: PropTypes.number,
      txnId: PropTypes.number,
      userName: PropTypes.string,
      x: PropTypes.number,
      y3: PropTypes.bool,
      y5: PropTypes.bool,
    })
  ),
  grantsData: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      availableBalance: PropTypes.number,
      charityName: PropTypes.string,
      checkClearedDate: PropTypes.number,
      checkNumber: PropTypes.number,
      csrDPFlow: PropTypes.bool,
      csrFlow: PropTypes.bool,
      currentBalance: PropTypes.number,
      dateRequested: PropTypes.number,
      dpUser: PropTypes.string,
      dpUserFirstName: PropTypes.string,
      dpUserLastName: PropTypes.string,
      dpUserMiddleName: PropTypes.string,
      dpUserPrefix: PropTypes.string,
      dpUserSuffix: PropTypes.string,
      enteredDate: PropTypes.number,
      grantAgreement: PropTypes.bool,
      isRecurring: PropTypes.string,
      issuedate: PropTypes.number,
      purpose: PropTypes.object,
      status: PropTypes.string,
      stopAndReissueChkDate: PropTypes.number,
      txnId: PropTypes.number,
      userName: PropTypes.string,
      x: PropTypes.number,
      y3: PropTypes.bool,
      y5: PropTypes.bool,
    })
  ),
  accountData: PropTypes.shape({
    accountId: PropTypes.string,
    accountName: PropTypes.string,
    availableBalance: PropTypes.number,
    beginBalance: PropTypes.number,
    currentBalance: PropTypes.number,
    dateChanged: PropTypes.number,
    endBalance: PropTypes.number,
    grantsAndContribution: PropTypes.number,
    grantsYTD: PropTypes.number,
    marketMovement: PropTypes.number,
    roleAccess: PropTypes.number,
    ytdPercentage: PropTypes.number,
    ytdPercentageIncrease: PropTypes.bool,
  }),
  grantsCount: PropTypes.shape({
    activeSchedules: PropTypes.number,
    availableBalance: PropTypes.number,
    currentBalance: PropTypes.number,
    grantAgreement: PropTypes.number,
    grantIssuedYTD: PropTypes.number,
    pendingGrant: PropTypes.number,
  }),
};
